import { Check, X } from "lucide-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface InsuranceDetailsCardProps {
  onSubmit: (carData: any) => void;
  onClose: () => void;
}

export const InsuranceDetailsCard = ({
  onSubmit,
  onClose,
}: InsuranceDetailsCardProps) => {
  const { t } = useTranslation();
  const [data, setData] = useState<{
    insuranceCompany: string;
    insuranceType?: string;
    insuranceNumber?: string;
  }>({ insuranceCompany: "", insuranceType: "", insuranceNumber: "" });
  const [buttonState, setButtonState] = useState(true);

  useEffect(() => {
    if (
      data?.insuranceCompany ||
      data?.insuranceNumber ||
      data?.insuranceType
    ) {
      setButtonState(false);
    } else {
      setButtonState(true);
    }
  }, [data]);

  const handleFinalSubmit = () => {
    onSubmit(data);
  };

  return (
    <div className="fixed animate-none inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div
        className="relative bg-popupLight dark:bg-popupDark text-primaryText dark:text-primaryTextDark shadow-lg rounded-2xl p-8 w-full max-w-lg mx-4 animate-fade-in-up"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 transition"
        >
          <X className="w-5 h-5" />
        </button>
        <h2 className="text-2xl font-bold text-center text-primaryText dark:text-primaryTextDark mb-4">
          {t("Insurance Details")}
        </h2>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium">
              {t("Insurance Company")}
            </label>
            <input
              type="text"
              value={data.insuranceCompany}
              onChange={(e) =>
                setData({ ...data, insuranceCompany: e.target.value })
              }
              className="mt-1 w-full px-4 py-2 rounded-md shadow-sm dark:bg-gray-700"
              placeholder="Tata Cliq"
            />
          </div>

          <div>
            <label className="block text-sm font-medium">
              {t("Insurance Type")}
            </label>
            <input
              type="text"
              value={data.insuranceType}
              onChange={(e) =>
                setData({ ...data, insuranceType: e.target.value })
              }
              className="mt-1 w-full px-4 py-2 rounded-md shadow-sm dark:bg-gray-700"
              placeholder="Comprehensive, Third Party"
            />
          </div>

          <div>
            <label className="block text-sm font-medium">{t("Model")}</label>
            <input
              type="text"
              value={data.insuranceNumber}
              onChange={(e) =>
                setData({ ...data, insuranceNumber: e.target.value })
              }
              className="mt-1 w-full px-4 py-2 rounded-md shadow-sm dark:bg-gray-700"
              placeholder="PNYH786GJ"
            />
          </div>

          <button
            disabled={buttonState}
            onClick={handleFinalSubmit}
            className="flex items-center gap-2 px-4 py-2 bg-secondaryText dark:bg-secondaryTextDark text-primaryText rounded-md disabled:cursor-not-allowed disabled:opacity-60"
          >
            <Check size={18} />
            {t("Update")}
          </button>
        </div>
      </div>
    </div>
  );
};
